import type { LucideIcon } from 'lucide-react';

interface HomeSectionTitleProps {
	icon: LucideIcon;
	children: React.ReactNode;
	/** `true` en las bandas de color, donde el título va sobre fondo oscuro. */
	oscuro?: boolean;
}

/**
 * Título de sección del home: versalitas con un icono a la izquierda.
 *
 * Vive en su propio archivo porque lo usan tanto la página (servidor) como el
 * slider y el bloque de registro (cliente), y las tres tienen que verse igual:
 * un mismo tamaño, un mismo espaciado y un icono del mismo peso. Cuando estaba
 * duplicado en cada una, se desincronizaban a la primera iteración.
 *
 * `oscuro` no solo cambia el color: sobre fondo de color el texto sube a
 * blanco 90% y el icono a 70%, porque el mismo gris que se lee bien sobre
 * blanco se apaga sobre el verde. Las dos variantes tienen que pesar IGUAL a la
 * vista, no llevar el mismo valor.
 */
export function HomeSectionTitle({ icon: Icon, children, oscuro = false }: HomeSectionTitleProps) {
	return (
		<h2
			className={`flex items-center gap-2.5 text-[15px] font-bold uppercase tracking-[0.1em] ${
				oscuro ? 'text-white/90' : 'text-slate-700'
			}`}
		>
			<Icon
				size={18}
				strokeWidth={2.2}
				aria-hidden
				className={oscuro ? 'text-white/70' : 'text-slate-500'}
			/>
			{children}
		</h2>
	);
}
